import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f7e3c10e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Change Selected Profile Name")

import { ref } from "vue";
import { useToggledValue } from "@/composition/use-toggled-value";
import BaseButton from "@/ui-library/base-button/base-button.vue";
import BaseIconEdit from "@/ui-library/base-icon/base-icon-edit.vue";
import BaseTooltip from "@/ui-library/base-tooltip/base-tooltip.vue";
import BaseButtonIcon from "@/ui-library/base-button/base-button-icon.vue";
import BaseButtonCancel from "@/ui-library/base-button/base-button-cancel.vue";
import BaseModal from "@/ui-library/base-modal/base-modal.vue";
import { useToastStore } from "@/features/toast-messages/store/toast-message-store";
import { createToastMessage } from "@/features/toast-messages/types/toast-message";
import { useChartGroupsStore } from "@/features/chart-groups/store/chart-groups-store";
import ChangeChartGroupNameForm from "./components/change-chart-group-name-form.vue";
import { createErrorToastMessage } from "@/features/toast-messages/types/toast-message";
import ChartGroupInfoDisplay from "./components/chart-group-info-display.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'change-chart-group-name',
  setup(__props) {

const { isTrue: isChangeNameModalOpen, toggleValue: toggleChangeNameModal } =
  useToggledValue();

const chartGroupStore = useChartGroupsStore();
const chartGroupName = ref("");
const toastStore = useToastStore();

const modalTitle = "Update Profile Name";
const submitText = "Submit";
const cancelText = "Cancel";

const resetAndClose = () => {
  chartGroupName.value = "";
  toggleChangeNameModal(false);
};

const updateChartGroupName = async (newName: string) => {
  if (!newName) {
    toastStore.toastNewMessage(
      createErrorToastMessage("New profile name cannot be blank", "long")
    );
    return;
  }
  try {
    await chartGroupStore.updateChartGroupName({
      id: Number(chartGroupStore.getSelectedChartGroupId),
      name: newName,
    });
    toastStore.toastNewMessage(
      createToastMessage("Profile name updated successfully!")
    );
  } catch (e) {
    toastStore.toastNewMessage(
      createErrorToastMessage("Failed to update profile name", "long")
    );
  } finally {
    resetAndClose();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BaseButtonIcon, {
      tertiary: "",
      class: "change-chart-group-name-button"
    }, {
      default: _withCtx(() => [
        _createVNode(BaseIconEdit, {
          onClick: _withModifiers(_unref(toggleChangeNameModal), ["prevent"])
        }, null, 8, ["onClick"]),
        _createVNode(BaseTooltip, { location: "bottom" }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(BaseModal, {
      title: modalTitle,
      isOpen: _unref(isChangeNameModalOpen),
      largeModal: "",
      clickOutsideToClose: ""
    }, {
      "footer-close-button": _withCtx(() => [
        _createVNode(BaseButtonCancel, { onClick: resetAndClose }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(cancelText))
          ]),
          _: 1
        })
      ]),
      "footer-affirmative-button": _withCtx(() => [
        _createVNode(BaseButton, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (updateChartGroupName(chartGroupName.value)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(submitText))
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(ChartGroupInfoDisplay),
        _createVNode(ChangeChartGroupNameForm, {
          modelValue: chartGroupName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((chartGroupName).value = $event)),
          tabIndexes: [0, 1],
          textAlign: 'left'
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["isOpen"])
  ], 64))
}
}

})